import { useFetchDocumentAttachments } from './useFetchDocumentAttachments'
import { queryKeys as documentQueryKeys, type QueryDocumentByIdCacheData } from '../useQueryDocument'

const create = () => {
  const { create } = useFetchDocumentAttachments()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: create,
    onMutate: (variables) => {
      queryClient.cancelQueries({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      })
    },
    onError: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      })
    },
    onSuccess: (responseData, variables) => {
      queryClient.setQueriesData<QueryDocumentByIdCacheData>({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      }, (oldData) => {
        if (!oldData)
          return oldData

        const updated = {
          ...oldData,
          data: {
            ...oldData.data,
            attachments: [...oldData.data.attachments, responseData.data],
          },
        }

        return updated
      }, {
        updatedAt: Date.now(),
      })
    },
  })
}

const drop = () => {
  const { drop } = useFetchDocumentAttachments()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: drop,
    onMutate: (variables) => {
      queryClient.cancelQueries({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      })
    },
    onError: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      })
    },
    onSuccess: (_, variables) => {
      queryClient.setQueriesData<QueryDocumentByIdCacheData>({
        queryKey: documentQueryKeys.byId({
          id: variables.documentId,
          workspaceId: variables.workspaceId,
        }).queryKey,
      }, (oldData) => {
        if (!oldData)
          return oldData

        const updated = {
          ...oldData,
          data: {
            ...oldData.data,
            attachments: oldData.data.attachments.filter(x => x.id !== variables.attachmentId),
          },
        }

        return updated
      }, {
        updatedAt: Date.now(),
      })
    },
  })
}

export const useMutationDocumentsAttachments = ({
  create,
  drop,
})
